let onestroyCarouselConfigs = {};

const initOnestoryCarousel = (onestoryCarousel, Glide, Controls, Breakpoints, Swipe) => {
    const id = onestoryCarousel.dataset.glideSliderId;
    if (onestoryCarousel.querySelectorAll('.glide__slide').length > 1) {
        onestroyCarouselConfigs[id] =
            new Glide(onestoryCarousel, {
                type: 'carousel',
                startAt: 0,
                perView: 1,
                breakpoints: {
                    // 1199: {
                    //   perView: 2
                    // },
                    767: {
                      perView: 1
                    }
                },
        });

        // turn off loading screan
        onestroyCarouselConfigs[id].on('mount.after', function() {
            onestoryCarousel.querySelector('.glide__track').classList.remove('loading');
        });

        onestroyCarouselConfigs[id].mount({ Controls, Breakpoints, Swipe });
    }
};

const onestoryCarousel = () => {
    const onestoryCarousels = document.querySelectorAll('.glide[data-glide-one-story-carousel-id]');
    
    if (onestoryCarousels && onestoryCarousels.length > 0) {
        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver(
                (entries, observer) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const carouselTarget = entry.target;
                            import("@glidejs/glide/dist/glide.modular.esm")
                                .then(({ default: Glide, Controls, Breakpoints, Swipe }) => {
                                    initOnestoryCarousel(carouselTarget, Glide, Controls, Breakpoints, Swipe);
                                })
                                .catch((error) => console.error("Error loading Glide.js", error));
                            observer.unobserve(carouselTarget);
                        }
                    });
                },
                { rootMargin: "200px 0px" }
            );

            Array.from(onestoryCarousels).forEach((carousel) => {
                observer.observe(carousel);
            });
        } else {
            import("@glidejs/glide/dist/glide.modular.esm")
                .then(({ default: Glide, Controls, Breakpoints, Swipe }) => {
                    Array.from(onestoryCarousels).forEach((carousel) => {
                        initOnestoryCarousel(carousel, Glide, Controls, Breakpoints, Swipe);
                    });
                })
                .catch((error) => console.error("Error loading Glide.js", error));
        }
    }
}

export default onestoryCarousel;
